module.exports = __webpack_public_path__ + "img/pic_coin_bigsale2@2x.8da620aa.png";